import { Loader } from './Loader';

/**
 * @deprecated Bitte direkt `<Loader variant='inline' size={300} />` aus
 * `components/generic/Loader` verwenden.
 */
export const CustomCircularProgress: React.FC = () => (
  <Loader variant='inline' size={300} height='50vh' />
);
